import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { LoadingButton } from "@mui/lab";
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import moment from 'moment';
import React, { useState } from "react";
import { CompanyFile } from '../../types/files';
import { getFileIcon } from "./folders/files";

const useStyles = makeStyles((theme) => ({
    fileName: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 1,
        wordBreak: 'break-word',
        overflow: 'hidden',
        textOverflow:'ellipsis',
        fontFamily: 'Inter',
        fontSize: '0.9rem',
        fontWeight: 600,
        color: '#666666',
    },
    date: {
        color: theme.palette.text.primary,
    },
    actionMenu: {
        height: 48,
        width: 48,
        marginRight: 10,
    },
    latestDeck: {
        minWidth: 150,
        borderRadius: 32,
        background: `${theme.colors.cyan['400']} !important`,
        color: `${theme.palette.common.white} !important`,
        fontSize: '0.9rem',
        fontWeight: 'bold',
        textTransform: 'none',
    },
    setDeck: {
        minWidth: 100,
        borderRadius: 32,
        fontSize: '0.95rem',
        fontWeight: '500',
        padding: `0 !important`,
        color: `${theme.colors.primary['500']} !important`,
        textTransform: 'none',
        "&:hover": {
            background: 'transparent',
            color: `${theme.colors.primary['700']} !important`,
            fontWeight: '600',
        }
    },
    icon: {
        color: theme.colors.primary['500'],
        width: 24,
        height: 24,
    },
    plainText: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        wordBreak: 'break-word',
        overflow: 'hidden',
        textOverflow:'ellipsis',
        fontFamily: 'Inter',
        fontSize: '0.85rem',
        color: '#666666',
    },
}));

const FileItem: React.FC<{
    file: CompanyFile,
    onFileSelect?: (file: CompanyFile) => void,
    onSetDeck?: (file: CompanyFile) => Promise<any>,
}> = ({ file, onFileSelect, onSetDeck }) => {
    const classes = useStyles();
    const [loading, setLoading] = useState<boolean>(false);;

    return (
        <Box onClick={() => onFileSelect?.(file)} width="100%">
            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start">
                    {getFileIcon(file.name || "")}
                    <Typography className={classes.fileName}>{file.name}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="flex-end">
                    {file.isDeck ? (
                        <Tooltip placement="top-start" title={
                                <Typography component="span" fontSize="1rem" fontWeight={600}>
                                    {`Latest deck/teaser`}
                                </Typography>
                            } componentsProps={{tooltip:{sx:{
                                display: 'flex', alignItems: 'center', borderRadius: '12px', transform: 'translate(-90px) !important',
                                backgroundColor: 'rgba(150, 150, 150, 0.95)', width: '170px', height: '45px',  padding: 2,
                            }}}}>
                            <CheckCircleIcon className={classes.icon} sx={{ transform: 'translateX(-5px)' }} />
                        </Tooltip>
                    ) : !!onSetDeck && (
                        <LoadingButton variant="text"
                            className={classes.setDeck}
                            loading={loading}
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                setLoading(true);
                                onSetDeck?.(file).then(() => setLoading(false));
                            }}> {'Set as latest'} </LoadingButton>
                    )}
                    <Typography className={classes.plainText}>
                        {moment(file.createdAt).fromNow()}
                    </Typography>
                </Stack>
            </Stack>
        </Box>
    );
};

export default FileItem;